import { type FC } from "react";
import PlotsComponent from "../../../../shared/layout/Plots";
import TreatmentComponent from "../../../../shared/layout/TreatmentBio";

const CropProtectionComponent: FC = () => {
  return (
    <div className="rates-main">
      <TreatmentComponent />
      <PlotsComponent from={"biologicals"} />
    </div>
  );
};

export default CropProtectionComponent;
